import { Stack } from '@mantine/core';

export const HomepageLayout = ({ children }) => {
  return <Stack spacing={64}>{children}</Stack>;
};
